import { useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../context/authContext';
import useHttp from './useHttp';

const useTimeMachine = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const getEffectiveTime = useCallback(async () => {
    try {
      return await sendRequest({
        url: '/api/v1/dev-tools/time-machine/effective-time',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });
    } catch (err) {
      toast.error('Fehler beim Abrufen der Serverzeit');
      throw err;
    }
  }, [authCtx, sendRequest]);

  const setOffsetMinutes = useCallback(
    async offsetMinutes => {
      try {
        return await sendRequest({
          url: '/api/v1/dev-tools/time-machine/offset',
          method: 'POST',
          headers: {
            ...authCtx.getAuthHeaders(),
            'Content-Type': 'application/json',
          },
          body: { offsetMinutes },
        });
      } catch (err) {
        toast.error('Fehler beim Setzen der Zeitverschiebung');
        throw err;
      }
    },
    [authCtx, sendRequest]
  );

  const resetOffset = useCallback(async () => {
    try {
      return await sendRequest({
        url: '/api/v1/dev-tools/time-machine/reset',
        method: 'POST',
        headers: authCtx.getAuthHeaders(),
      });
    } catch (err) {
      toast.error('Fehler beim Zurücksetzen der Zeitverschiebung');
      throw err;
    }
  }, [authCtx, sendRequest]);

  return { getEffectiveTime, setOffsetMinutes, resetOffset };
};

export default useTimeMachine;
